import apiClient from "./apiClient";

const getMe = async () => {
  const response = await apiClient.get("/users/me");
  return response.data;
};

const saveMe = async (payload) => {
  const response = await apiClient.put("/users/me", payload);
  return response.data;
};

const listSellerApprovals = async (pendingOnly = false) => {
  const response = await apiClient.get("/users/seller-approvals", {
    params: {
      pending_only: pendingOnly,
    },
  });
  return response.data;
};

const updateSellerApproval = async (userId, approved) => {
  const response = await apiClient.put(`/users/${userId}/seller-approval`, {
    approved,
  });
  return response.data;
};

const UserProfileService = {
  getMe,
  saveMe,
  listSellerApprovals,
  updateSellerApproval,
};

export default UserProfileService;

